export const PROFILE_TYPE_LEAD = 'lead'
export const PROFILE_TYPE_CUSTOMER = 'customer'
export const PROFILE_TYPE_CONSULTANT = 'consultant'